import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from './modal.component';
import {CurrentPasswordComponent} from './components/current-password/current-password.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalDirective} from './directives/modal.directive';
import {AddVehicleComponent} from './components/add-vehicle/add-vehicle.component';
import {RemoveComponent} from './components/remove/remove.component';
import {ChangeStatusComponent} from './components/change-status/change-status.component';
import {SpinnerModule} from '../spinner/spinner.module';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextModule} from 'primeng/inputtext';
import {TranslateModule} from '@ngx-translate/core';
import {AddGoalComponent} from './components/add-goal/add-goal.component';
import {AddCostComponent} from './components/add-cost/add-cost.component';
import {PickListModule} from 'primeng/picklist';
import {CalendarModule} from 'primeng/calendar';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {InputSwitchModule} from 'primeng/inputswitch';
import {ColorPickerModule} from 'primeng/colorpicker';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SelectButtonModule} from 'primeng/selectbutton';
import {FileUploadModule} from 'primeng/fileupload';
import {RippleModule} from 'primeng/ripple';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {ThumbnailModule} from '../thumbnail/thumbnail.module';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {PipesModule} from '../../core/pipes/pipes.module';
import {SkeletonModule} from 'primeng/skeleton';
import {ProjectDescriptionComponent} from './components/project-description/project-description.component';
import {HtmlEditorModule} from '../html-editor/html-editor.module';
import {EndCapModule} from '../end-cap/end-cap.module';
import {CardModule} from 'primeng/card';
import {HistoryPostComponent} from './components/history-post/history-post.component';
import {TableModule} from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import {InputNumberModule} from 'primeng/inputnumber';
import {AddMediaComponent} from './components/add-media/add-media.component';
import {AddEventComponent} from './components/add-event/add-event.component';
import {EditorModule} from 'primeng/editor';
import {ChipModule} from 'primeng/chip';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {RxReactiveFormsModule} from '@rxweb/reactive-form-validators';
import {ParticipationListComponent} from './components/participation-list/participation-list.component';
import {OverlayGalleryComponent} from './components/overlay-gallery/overlay-gallery.component';
import {SwiperModule} from 'swiper/angular';
import {MediaViewModule} from '../media-view/media-view.module';
import {NgxPermissionsModule} from 'ngx-permissions';
import {EmojiModule} from '@ctrl/ngx-emoji-mart/ngx-emoji';
import {SpeedDialModule} from '../speed-dial/speed-dial.module';
import {ItemActionDialComponent} from './components/item-action-dial/item-action-dial.component';
import {CustomCameraPageModule} from '../../features/custom-camera/custom-camera.module';
import {ConfirmDialogComponent} from './components/confirm-dialog/confirm-dialog.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MapModule} from '../map/map.module';
import {AddressPickerComponent} from '../address-picker/address-picker.component';
import {HashtagsModule} from '../hashtags/hashtags.module';
import {SearchFiltersComponent} from './components/search-filters/search-filters.component';
import {SliderModule} from "primeng/slider";
import {FieldsetModule} from "primeng/fieldset";
import {
  AddVehicleAdvertisementComponent
} from "./components/add-vehicle-advertisement/add-vehicle-advertisement.component";
import {StepperModule} from "primeng/stepper";
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {AvatarModule} from "primeng/avatar";
import {ImageCropDialogComponent} from '../image-cropper/image-crop-dialog.component';
import {MediaUploaderComponent} from "../media/media-uploader/media-uploader.component";
import {PanelModule} from "primeng/panel";
import {TranslateCollectionOrItemPipe} from "../../core/pipes/translate-collection-or-item.pipe";
import {MultiSelectModule} from "primeng/multiselect";
import {FloatLabelModule} from "primeng/floatlabel";
import {AccordionModule} from "primeng/accordion";
import {SocialActionsComponent} from "../social/social-actions/social-actions.component";
import {SocialModule} from "../social/social.module";
import {BottomSheetComponent} from "../components/bottom-sheet/bottom-sheet.component";
import {BottomSheetAvailablePipe} from "../../core/pipes/bottom-sheet-available.pipe";
import {NgxLongPress2Module} from "ngx-long-press2";
import {ChangeMainOwnerComponent} from "./components/change-main-owner/change-main-owner.component";
import {InputOtpModule} from "primeng/inputotp";
import {StyleClassModule} from "primeng/styleclass";
import {AddDocumentsComponent} from "./components/add-documents/add-documents.component";
import {BadgeModule} from "primeng/badge";
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {TabViewModule} from "primeng/tabview";
import {ViolationComponent} from "./components/violation/violation.component";
import {NativeVideoPreviewModule} from "../media/native-video-preview/native-video-preview.module";
import {BugReportComponent} from "./components/bug-report/bug-report.component";
import {ProgressBarModule} from "primeng/progressbar";
import {MobileFocusManagerDirective} from "./directives/mobile-focus-manager.directive";
import {QrDialogComponent} from "../qr/qr-dialog.component";
import {SocialListModalComponent} from './components/social-list/social-list-modal.component';
import {SocialListItemHostComponent} from './components/social-list/social-list-item-host.component';
import {ReactionListItemComponent} from './components/social-list/items/reaction-list-item.component';
import {FollowListItemComponent} from './components/social-list/items/follow-list-item.component';
import {PlaceCheckInListItemComponent} from './components/social-list/items/place-check-in-list-item.component';
import {PostComposerModalComponent} from './components/post-composer/post-composer-modal.component';
import {ChatShareModalComponent} from './components/chat-share/chat-share-modal.component';
import {ShareCardComponent} from '../share/share-card.component';
import {PostSourceHeaderComponent} from '../timeline/post-source-header/post-source-header.component';
import {PlaceFiltersComponent} from './components/place-filters/place-filters.component';
import {AddPlaceComponent} from './components/add-place/add-place.component';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SpinnerModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        TooltipModule,
        InputTextModule,
        TranslateModule,
        PickListModule,
        CalendarModule,
        InputTextareaModule,
        InputSwitchModule,
        ColorPickerModule,
        RadioButtonModule,
        FormsModule,
        SelectButtonModule,
        FileUploadModule,
        RippleModule,
        VirtualScrollerModule,
        ThumbnailModule,
        TieredMenuModule,
        PipesModule,
        SkeletonModule,
        HtmlEditorModule,
        EndCapModule,
        CardModule,
        TableModule,
        CheckboxModule,
        InputNumberModule,
        EditorModule,
        ChipModule,
        AutoCompleteModule,
        RxReactiveFormsModule,
        SwiperModule,
        MediaViewModule,
        NgxPermissionsModule,
        EmojiModule,
        SpeedDialModule,
        CustomCameraPageModule,
        ConfirmDialogModule,
        MapModule,
        AddressPickerComponent,
        HashtagsModule,
        SliderModule,
        FieldsetModule,
        StepperModule,
        InputGroupModule,
        InputGroupAddonModule,
        AvatarModule,
        MediaUploaderComponent,
        ImageCropDialogComponent,
        PanelModule,
        TranslateCollectionOrItemPipe,
        MultiSelectModule,
        FloatLabelModule,
        AccordionModule,
        SocialActionsComponent,
        SocialModule,
        BottomSheetComponent,
        BottomSheetAvailablePipe,
        NgxLongPress2Module,
        InputOtpModule,
        StyleClassModule,
        BadgeModule,
        NgxExtendedPdfViewerModule,
        TabViewModule,
        NativeVideoPreviewModule,
        ProgressBarModule,
        QrDialogComponent,
        ShareCardComponent,
        PostSourceHeaderComponent
    ],
  declarations: [
    ModalComponent, CurrentPasswordComponent, ModalDirective, MobileFocusManagerDirective, AddVehicleComponent, RemoveComponent, OverlayGalleryComponent,
    ChangeStatusComponent, SocialListModalComponent, SocialListItemHostComponent, ReactionListItemComponent, FollowListItemComponent, PlaceCheckInListItemComponent,
    AddGoalComponent, ProjectDescriptionComponent, HistoryPostComponent,
    AddCostComponent,
    AddMediaComponent, AddEventComponent, ParticipationListComponent, OverlayGalleryComponent, ItemActionDialComponent, ConfirmDialogComponent,
    SearchFiltersComponent, AddVehicleAdvertisementComponent, ChangeMainOwnerComponent, AddDocumentsComponent, ViolationComponent,
    BugReportComponent, PostComposerModalComponent, ChatShareModalComponent, PlaceFiltersComponent, AddPlaceComponent
  ],
  exports: [ModalComponent, ConfirmDialogComponent, AddVehicleComponent, SearchFiltersComponent, MobileFocusManagerDirective]
})
export class ModalModule {
}
